import React from "react";
import { Form, Col, InputGroup } from "react-bootstrap";
import { useField, useFormikContext } from "formik";
import WindowedSelect from "react-windowed-select";

import { getValidationClassName } from "../validation";
import FieldErrors from "../FieldErrors";
import { getViewMode } from "../../../utils";
import { getCustomStylesForWSelect } from "./customStyles";
import { logout } from "../../../actions";

const WSelect = ({
  label,
  options = [],
  emptyValue = "",
  md = "",
  isClearable = true,
  submitRef = undefined,
  ...props
}) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const isViewMode = getViewMode();
  const isDisabled = props.disabled || isViewMode;

  // Search value into possibly nested options (for now we search up to 1 nested level)
  const findOption = value => {
    let flattenedOpts = [];

    options.forEach(opt => {
      if (opt.options) {
        flattenedOpts = [...flattenedOpts, ...opt.options];
      } else {
        flattenedOpts.push(opt);
      }
    });
    return flattenedOpts.find(opt => opt.value === value);
  };

  let initialValue;
  if (field.value !== undefined && field.value !== emptyValue) {
    initialValue = findOption(field.value);
  } else {
    if (props.defaultValue !== undefined) {
      initialValue = findOption(props.defaultValue);
    } else {
      initialValue = emptyValue;
    }
  }

  const defaultOnChange = option => {
    let value;
    if (option === null) {
      value = props.defaultValue !== undefined ? props.defaultValue : emptyValue;
    } else {
      value = option.value;
    }
    setFieldValue(field.name, value);
    if (props.onChangeCallback) {
      props.onChangeCallback(option);
    }
  };

  const validateClassName = getValidationClassName(meta);
  const customStyles = getCustomStylesForWSelect(isDisabled);
  let placeholder = isDisabled ? "---" : props.placeholder;

  return (
    <Form.Group as={Col} sm="12" className={`col-md${md && "-" + md} padding0`}>
      {props.append ? props.append : null}
      <InputGroup style={{ flexWrap: "nowrap" }}>
        {label && (
          <InputGroup.Prepend>
            <InputGroup.Text>
              <div style={{ marginLeft: 1, marginRight: 3 }}>{label}</div>
              {props.icon}
            </InputGroup.Text>
          </InputGroup.Prepend>
        )}
        <div style={{ flexGrow: 1 }} className={validateClassName}>
          <WindowedSelect
            {...props}
            filterOption={(option, inputValue) => {
              if (!inputValue) return true;
              const lowerInput = inputValue.toLowerCase();
              const lowerLabel = option.label.toLowerCase();
              // Check if the entire label starts with input
              if (lowerLabel.startsWith(lowerInput)) return true;
              // Check if any word in the label starts with input
              return lowerLabel.split(/\s+/).some(word => word.startsWith(lowerInput));
            }}
            placeholder={placeholder}
            maxMenuHeight={200}
            name={field.name}
            options={options}
            value={initialValue}
            onChange={props.onChange || defaultOnChange}
            className={`select ${validateClassName}`}
            isClearable={isClearable}
            menuPlacement={props.menuPlacement || "auto"}
            styles={customStyles}
            isDisabled={isDisabled || false}
            ref={submitRef}
            classNamePrefix="case-form-select"
            menuPortalTarget={document.body}
          />
          <FieldErrors meta={meta} />
        </div>
      </InputGroup>
    </Form.Group>
  );
};

export default WSelect;
